import React from "react";
import { Outlet } from "react-router-dom";
import { ApplicantChecksProvider } from "@/components/provider/ApplicantChecksProvider";

const ApplicantChecksLayout = () => {
  return (
    <ApplicantChecksProvider>
      <Outlet />
    </ApplicantChecksProvider>
  );
};

export default ApplicantChecksLayout;
